var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "nav",
      {
        staticClass: "navbar navbar-expand-lg navbar-dark",
        staticStyle: { "background-color": "#461227" }
      },
      [
        _c(
          "div",
          { staticClass: "container d-flex flex-column align-items-center" },
          [
            _c(
              "a",
              {
                staticClass: "navbar-brand font-weight-light",
                staticStyle: { "margin-right": "0rem" },
                attrs: { href: "https://sarasch.com/", target: "_blank" }
              },
              [
                _c("img", {
                  staticClass: "d-inline-block align-top",
                  attrs: {
                    src: "/img/logo_header.png",
                    alt: "Logo Sara Schenirer Application"
                  }
                })
              ]
            )
          ]
        )
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6dde423b", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dde423b","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Navbar.vue
// module id = 415
// module chunks = 19